export default __webpack_public_path__ + "static/media/fnb-sample.23dd63be.jpg";